import { makeStyles } from '@material-ui/core/styles';

export const useBulkEmailSectionsCollapserStyles = makeStyles(theme => ({
  header: {
    margin: theme.spacing(1, 3)
  },
  divider: {
    height: 2
  },
  collapse: {
    padding: theme.spacing(0, 3),
    width: '100%'
  }
}));
